module.exports = __webpack_public_path__ + "static/media/profile.0e7de2bb.webp";